import {useOutletContext} from "react-router-dom";
import {EntityViewSubPage} from "base/entity";
import {EDARDesenoSection} from "../presentational/section";

const ViewEDARDesenoSubPage = () => {
    let edar;
    [edar] = useOutletContext();

    const sections = [<EDARDesenoSection edar={edar} />];

    return edar && <EntityViewSubPage sections={sections} />;
};

export default ViewEDARDesenoSubPage;
